import { EnvironmentDetail, RegionMappingService } from '@amzn/ihm-associate-tools-js-lib'
import { AssetRegistration } from '@amzn/jwo-store-management-platform-registration'
import { currentAppHostOrigin } from '@utils/AppHostUtil'
import { getDomainFromHostname } from '@utils/EnvironmentUtil'

/**
 * Root URL for an asset's files. On a regional app host: the page's own origin (same distribution
 * as the shell). Otherwise: `https://{awsRegion}.{domain}.storemanagement.jihm.amazon.dev/assets/{assetId}`.
 */
export const getAssetBaseUrl = (assetId: string): string => {
    const appOrigin = currentAppHostOrigin()
    if (appOrigin) {
        return `${appOrigin}/assets/${assetId}`
    }
    const domain = getDomainFromHostname()
    const region = EnvironmentDetail.getRegion() || 'pdx'
    const realm = RegionMappingService.getAwsRegionFromAirportCode(region) || 'us-west-2'
    return `https://${realm}.${domain}.storemanagement.jihm.amazon.dev/assets/${assetId}`
}

/** Absolute URL of a tool's registered icon; `asset.icon` is relative to the asset root. */
export const getAssetIconUrl = (asset: AssetRegistration): string | undefined => {
    if (!asset?.icon) {
        return undefined
    }
    return `${getAssetBaseUrl(asset.assetId)}/${asset.icon}`
}
